import {
	cardTitleProps,
	tdProps,
	thProps,
	tableDescriptionProps,
	ulsContentProps,
} from '../../common';
import {courseImg, courseImg1} from '../../../config/images';
import {colorPalette} from '../../../config';

// export const imageProps = {
// 	src: courseImg,
// 	alt: '코스',
// 	borderRadius: '1.375rem',
// 	border: `1px solid ${colorPalette.border}`,
// };
// export const imagePropsTitle = {
// 	title: {
// 		text: {children: '대회코스', ...cardTitleProps},
// 	},
// };
export const imageProps = {
	title: {
		textAlign: 'left',
		bgColor: colorPalette.primary,
		height: '5px',
		text: {children: '대회코스', ...cardTitleProps, type: 'p'},
	},
	course: {
		src: courseImg,
		alt: '코스',
		borderRadius: '1.375rem',
	},
	course1: {
		src: courseImg1,
		alt: '코스',
		borderRadius: '1.375rem',
	},
};

export const limitTime = {
	title: {
		text: {children: '코스별 제한시간', ...cardTitleProps},
	},
	table: {
		ths: [
			{...thProps, children: '종목'},
			{...thProps, children: '출발시간'},
			{...thProps, children: '제한시간'},
			{...thProps, children: '구간'},
		],
		trs: [
			[
				{...tdProps, children: '하프코스'},
				{...tdProps, children: '08:30'},
				{...tdProps, children: '3시간(11:30)'},
				{
					...tdProps,
					children:
						' 공설운동장(씨름장 쪽 출발)→용방초교→자연드림\n→세침교 인근 농로(반환)→용방초 →서시천자전거길\n→공설운동장(게이트볼장 쪽 도착)',
				},
			],
			[
				{...tdProps, children: '10km'},
				{...tdProps, children: '08:40'},
				{...tdProps, children: '2시간(10:40)'},
				{
					...tdProps,
					children:
						' 공설운동장(씨름장 쪽 출발)→용방초교 가기 전 농로\n→서시천자전거길→공설운동장(게이트볼장 쪽 도착)',
				},
			],
			[
				{...tdProps, children: '5km'},
				{...tdProps, children: '08:50'},
				{...tdProps, children: '1시간(09:50)'},
				{
					...tdProps,
					children:
						' 공설운동장(씨름장 쪽 출발)→사우마을 입구\n→공설운동장(씨름장 쪽 도착)',
				},
			],
		],
		descriptions: [
			{
				content: {
					...tableDescriptionProps,
					children: `제한 시간이 넘었음에도 불구하고 주최 측 회송차량 승차를 거부한 채 계속 주행하던 도중에 발생하는 사고에 대한 모든 책임은 참가자 본인에게 있으며, 주최 측은 책임을 지지 않습니다.`,
				},
			},
		],
	},
};

export const warningText = {
	items: [
		{
			content: {
				...ulsContentProps,
				children: '상기 코스는 대회 운영 여건에 맞춰 변동될 수 있습니다.',
			},
		},
	],
};